import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useSingleResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useSingleResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum VideoAttachmentContentPropertyValidation {
    FILE_NAME = 'FILE_NAME',
    FILE_CONTENT = 'FILE_CONTENT',
}

export const VideoAttachmentContentResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.VIDEO_ATTACHMENT_CONTENT).default(ResourceType.VIDEO_ATTACHMENT_CONTENT),
    fileName: z.string(),
    fileContent: z.string(),
});
export const VideoAttachmentContentMutationResourceSchema = getMutationSchema(VideoAttachmentContentResourceSchema);

export type VideoAttachmentContentResource = z.infer<typeof VideoAttachmentContentResourceSchema>;

export const defaultVideoAttachmentContentResource: VideoAttachmentContentResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.VIDEO_ATTACHMENT_CONTENT,
    fileName: '',
    fileContent: '',
};

export function useVideoAttachmentContentActions() {
    return {
        ...useSingleResourceSingleParentedResourceAdapterActions(
            'project/video-attachment-content',
            ResourceType.VIDEO_ATTACHMENT_CONTENT,
            VideoAttachmentContentResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/video-attachment-content',
            ResourceType.VIDEO_ATTACHMENT_CONTENT,
            VideoAttachmentContentResourceSchema
        ),
    };
}
